/* CÃOBUM! – scripts leves do tema (sem dependências) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------
     Slider principal
  ------------------------------------------------------------------ */
  function CbSlider(root) {
    this.root = root;
    this.track = root.querySelector('[data-cb-track]');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-cb-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-cb-dot]'));
    this.toggleBtn = root.querySelector('[data-cb-toggle]');
    this.index = 0;
    this.timer = null;
    this.userPaused = false;
    this.tempPaused = false;
    this.interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    this.autoplay = root.getAttribute('data-autoplay') === 'true' && this.slides.length > 1;
    if (!this.track || this.slides.length === 0) return;

    if (reduceMotion && this.autoplay) {
      this.userPaused = true;
    }
    this.bind();
    this.setActive(0);
    this.syncToggle();
    this.start();
  }

  CbSlider.prototype.bind = function () {
    var self = this;
    var prev = this.root.querySelector('[data-cb-prev]');
    var next = this.root.querySelector('[data-cb-next]');
    if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); self.restart(); });
    if (next) next.addEventListener('click', function () { self.go(self.index + 1); self.restart(); });
    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        self.go(parseInt(dot.getAttribute('data-cb-dot'), 10));
        self.restart();
      });
    });
    if (this.toggleBtn) {
      this.toggleBtn.addEventListener('click', function () {
        self.userPaused = !self.userPaused;
        self.syncToggle();
        self.userPaused ? self.stop() : self.start();
      });
    }

    var scrollTimer;
    this.track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var w = self.track.clientWidth || 1;
        var i = Math.round(self.track.scrollLeft / w);
        if (i !== self.index) self.setActive(i);
      }, 90);
    }, { passive: true });

    this.track.addEventListener('pointerdown', function () { self.restart(); }, { passive: true });

    this.root.addEventListener('mouseenter', function () { self.tempPaused = true; self.stop(); });
    this.root.addEventListener('mouseleave', function () { self.tempPaused = false; self.start(); });
    this.root.addEventListener('focusin', function () { self.tempPaused = true; self.stop(); });
    this.root.addEventListener('focusout', function (e) {
      if (!self.root.contains(e.relatedTarget)) { self.tempPaused = false; self.start(); }
    });
    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { self.go(self.index - 1); }
      if (e.key === 'ArrowRight') { self.go(self.index + 1); }
    });
    document.addEventListener('visibilitychange', function () {
      document.hidden ? self.stop() : self.start();
    });
    window.addEventListener('resize', function () {
      self.track.scrollTo({ left: self.index * self.track.clientWidth, behavior: 'auto' });
    });
  };

  CbSlider.prototype.go = function (i) {
    var n = this.slides.length;
    i = (i + n) % n;
    this.track.scrollTo({ left: i * this.track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    this.setActive(i);
  };

  CbSlider.prototype.setActive = function (i) {
    this.index = i;
    this.slides.forEach(function (slide, k) {
      var active = k === i;
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      if (active) { slide.removeAttribute('inert'); } else { slide.setAttribute('inert', ''); }
    });
    this.dots.forEach(function (dot, k) {
      if (k === i) { dot.setAttribute('aria-current', 'true'); } else { dot.removeAttribute('aria-current'); }
    });
  };

  CbSlider.prototype.start = function () {
    var self = this;
    this.stop();
    if (!this.autoplay || this.userPaused || this.tempPaused || document.hidden) return;
    this.timer = setInterval(function () { self.go(self.index + 1); }, this.interval);
  };

  CbSlider.prototype.stop = function () {
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
  };

  CbSlider.prototype.restart = function () {
    if (!this.tempPaused) this.start();
  };

  CbSlider.prototype.syncToggle = function () {
    if (!this.toggleBtn) return;
    this.toggleBtn.setAttribute('aria-pressed', this.userPaused ? 'true' : 'false');
    this.toggleBtn.setAttribute('aria-label', this.userPaused ? 'Retomar troca automática' : 'Pausar troca automática');
    this.toggleBtn.classList.toggle('is-paused', this.userPaused);
  };

  function initSliders(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-cb-slider]'), function (el) {
      if (el.__cbSlider) return;
      el.__cbSlider = new CbSlider(el);
    });
  }

  /* ------------------------------------------------------------------
     "Adicionar ao carrinho" direto do card
  ------------------------------------------------------------------ */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-cb-quick-add') || !window.fetch) return;
    event.preventDefault();

    var button = form.querySelector('[data-cb-add]');
    var label = button ? button.querySelector('.cb-btn__label') : null;
    var original = label ? label.textContent : '';
    if (button) { button.disabled = true; button.classList.add('is-loading'); }

    var addUrl = ((window.routes && window.routes.cartAddUrl) || '/cart/add') + '.js';

    fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form), credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('add');
        return response.json();
      })
      .then(function (item) {
        if (label) label.textContent = 'Adicionado!';
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { variant: item, quantity: item.quantity || 1 }
        }));
        if (window.theme && window.theme.cartType === 'page') {
          window.location.href = (window.routes && window.routes.cartUrl) || '/cart';
        }
        setTimeout(function () { if (label) label.textContent = original; }, 1800);
      })
      .catch(function () {
        HTMLFormElement.prototype.submit.call(form);
      })
      .then(function () {
        if (button) { button.disabled = false; button.classList.remove('is-loading'); }
      });
  });

  /* ------------------------------------------------------------------
     Parcelamento: atualiza quando o cliente troca a variação
  ------------------------------------------------------------------ */
  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL';
    try {
      return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: currency });
    } catch (e) {
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  function cbInstallments(price, el) {
    var max = parseInt(el.getAttribute('data-max'), 10) || 1;
    var min = parseInt(el.getAttribute('data-min'), 10) || 0;
    var free = el.getAttribute('data-free') === 'true';
    var rate = parseFloat(el.getAttribute('data-rate')) || 0;
    var n = 1, parcel = price;
    for (var k = 2; k <= max; k++) {
      var p;
      if (free || rate <= 0) {
        p = price / k;
      } else {
        var f = Math.pow(1 + rate, k);
        p = price * rate * f / (f - 1);
      }
      if (p >= min) { n = k; parcel = p; }
    }
    return { n: n, value: Math.round(parcel) };
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-cb-installments]'), function (el) {
      var r = cbInstallments(variant.price, el);
      el.hidden = r.n < 2 || !variant.available;
      var nEl = el.querySelector('[data-cb-inst-n]');
      var vEl = el.querySelector('[data-cb-inst-v]');
      if (nEl) nEl.textContent = r.n + 'x';
      if (vEl) vEl.textContent = formatMoney(r.value);
    });
    /* Valor do desconto ("R$ 60 de desconto") */
    Array.prototype.forEach.call(document.querySelectorAll('[data-cb-savings]'), function (el) {
      var save = (variant.compare_at_price || 0) - variant.price;
      el.hidden = !(save > 0);
      var amt = el.querySelector('[data-cb-savings-v]');
      if (amt && save > 0) amt.textContent = formatMoney(save).replace(/,00$/, '');
    });
  });

  /* ------------------------------------------------------------------
     Botões de quantidade da página de produto (mínimo 1)
  ------------------------------------------------------------------ */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('.qtyminus, .qtyplus') : null;
    if (!btn) return;
    event.preventDefault();
    var wrap = btn.parentNode;
    var input = wrap ? wrap.querySelector('input[name="quantity"]') : null;
    if (!input) return;
    var value = parseInt(input.value, 10) || 1;
    value = btn.classList.contains('qtyplus') ? value + 1 : Math.max(1, value - 1);
    input.value = value;
  });

  /* ------------------------------------------------------------------
     Inicialização (inclui o editor de temas)
  ------------------------------------------------------------------ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initSliders(); });
  } else {
    initSliders();
  }
  document.addEventListener('shopify:section:load', function (e) { initSliders(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest ? e.target.closest('[data-cb-slider]') : null;
    if (root && root.__cbSlider) {
      var i = root.__cbSlider.slides.indexOf(e.target);
      if (i > -1) { root.__cbSlider.userPaused = true; root.__cbSlider.stop(); root.__cbSlider.go(i); }
    }
  });
})();
